import { Layout } from '@/components/layouts/layout';
import { OrdersIndex, ScheduleSelections } from '@/components/pages';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ErrorPage } from './components/shared';

export const routes = {
  scheduleSelections: '/schedule_adjustments/:token',
  orders: '/orders/:token',
  oldScheduleSelections: '/old/schedule_adjustments/:token'
};

export const Router: React.FC = () => {
  return (
    <Routes>
      <Route path={routes.scheduleSelections} element={<Layout component={<ScheduleSelections />} />} />
      <Route path={routes.orders} element={<Layout component={<OrdersIndex />} />} />
      <Route path={'*'} element={<ErrorPage type={'NotFound'} />} />
    </Routes>
  );
};
